// extracted by mini-css-extract-plugin
export var col = "footer-module--col--CHWMb";
export var footer = "footer-module--footer--lU7l1";
export var footerWrap = "footer-module--footerWrap--ZF8t-";
export var item = "footer-module--item--FoMuc";
export var left = "footer-module--left--Fv12b";
export var right = "footer-module--right--9fGsV";
export var row = "footer-module--row--2Pycj";